import { useState } from "react";
import "./detailpage.css";
import arthroscopyshaverimage from "../../images/ArthroscopicShaver-Blade.png";
import hipudrapebanner from "../../images/orthopedic-page-banner.jpg";
import { FaWhatsapp } from "react-icons/fa";
import shaverblades from "../../images/shaverblade.jpg";

const whatsappMessage = `https://wa.me/+919619065205?text=Hi! I'm interested in your medical products. Please provide more information.`;
const whatsappNumber = "+919619065205";

const ArthroscopyShaverBlades = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="page-sagittal">
      <nav class="breadcrumbs">
        <a href="/">Home</a> <span>›</span> <a href="/products">Products</a>
        <span>›</span> <a href="/products/surgical-consumables">Arthroscopy</a>
        <span>›</span>
        Arthroscopy Shaver Blades
      </nav>
      {/* Hero Section */}
      <section
        className="homepage-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${hipudrapebanner})`,
        }}
      >
        <h1 className="homepage-hero-title"> Arthroscopy Shaver Blades</h1>
        <p className="homepage-hero-subtext">
          Disposable shaver blades for minimally invasive joint surgery,
          available with multiple head geometries and coupling types to match
          leading arthroscopy shaver systems.
        </p>
        <div className="homepage-hero-buttons">
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in bulk procurement of Arthroscopy Shaver Blades
. Please share more details.`}
            className="homepage-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request Quote
          </a>
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hi! I'd like to receive a brochure of your surgical gown offerings.`}
            className="homepage-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request Brochure
          </a>
        </div>
      </section>
      <section class="product-header">
        <div class="media-card">
          <div class="main-image">
            <img
              src={arthroscopyshaverimage}
              alt="Arthroscopy Shaver Blades - Sabiote 
Healthcare"
            />
          </div>
          <div class="thumb-row">
            <div class="thumb">
              <img
                src={arthroscopyshaverimage}
                alt="Sterile packed arthroscopy shaver 
blades"
              />
            </div>
            <div class="thumb">
              <img
                src={arthroscopyshaverimage}
                alt="Different shaver blade head types"
              />
            </div>
            <div class="thumb">
              <img
                src={arthroscopyshaverimage}
                alt="Shaver blade coupling types"
              />
            </div>
            <div class="thumb">
              <img
                src={arthroscopyshaverimage}
                alt="Blade in arthroscopic setup 
(staged)"
              />
            </div>
          </div>
        </div>
        <div>
          <div class="badge-row">
            <span class="badge badge--primary">Arthroscopy</span>
            <span class="badge">Multiple head types</span>
            <span class="badge">Multi-system compatible</span>
          </div>
          <h1>Arthroscopy Shaver Blades</h1>
          <p class="subtitle">
            Disposable shaver blades for minimally invasive joint surgery,
            available with multiple head geometries and coupling types to match
            leading arthroscopy shaver systems.
          </p>
          <div class="meta-row">
            <div>
              <span class="meta-label">Material:</span> Medical grade stainless
              steel
            </div>
            <div>
              <span class="meta-label">Use:</span> Soft tissue &amp; bone
              debridement
            </div>
            <div>
              <span class="meta-label">Design:</span> Single-use, sterile*
            </div>
          </div>
          <div class="chip-row">
            <div class="chip">
              <img
                src={shaverblades}
                alt="Arthroscopy Shaver Blades
 - Sabiote Healthcare"
              />
              Straight, serrated, taper &amp; burr heads
            </div>
            <div class="chip">
              <img
                src={shaverblades}
                alt="Arthroscopy Shaver Blades
 - Sabiote Healthcare"
              />
              Multiple diameters (e.g. 3.5–5.5 mm)
            </div>
            <div class="chip">
              <img
                src={shaverblades}
                alt="Arthroscopy Shaver Blades
 - Sabiote Healthcare"
              />
              System-specific couplings
            </div>
            <div class="chip">
              <img
                src={shaverblades}
                alt="Arthroscopy Shaver Blades
 - Sabiote Healthcare"
              />
              Custom/OEM configurations
            </div>
          </div>
          <p class="excerpt">
            Sabiote arthroscopy shaver blades are designed for precise tissue
            resection and debridement in knee, shoulder, hip and other joint
            procedures. Optimised cutting windows, balanced shafts and tuned
            clearances help deliver reliable performance and controlled cutting,
            while a wide choice of head designs and handpiece couplings supports
            seamless integration into your existing arthroscopy setup.
          </p>
          <div class="cta-row">
            <a
              href="https://wa.me/+919619065205?text=Hello! I'm interested in bulk procurement of Arthroscopy Shaver Blades. Please share more details."
              className="btn btn-primary"
            >
              Configure &amp; Request Quote
              <svg viewBox="0 0 20 20" fill="none">
                <path
                  d="M5 10h8m0 0-3-3m3 3-3 3"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </a>
            <a href="#downloads" class="btn btn-outline">
              Download Shaver Blade Catalog
            </a>
            <span class="note">OEM / distributor enquiries welcome.</span>
          </div>
          <div class="pill-label">
            <span>Key Procedures:</span> Meniscus &amp; cartilage work,
            synovectomy, labral &amp; rotator cuff, general joint debridement
          </div>
          <div>
            <div class="card-subtitle">Head Types</div>
            <p class="note">
              Representative head geometries – select based on target tissue
              (soft tissue, synovium, cartilage, bone) and joint.
            </p>
            <div class="head-strip">
              <div class="head-item">
                <img
                  src={arthroscopyshaverimage}
                  alt="Straight open shaver head"
                />
                Straight • Open Window
              </div>
              <div class="head-item">
                <img
                  src={arthroscopyshaverimage}
                  alt="Aggressive serrated shaver head"
                />
                Serrated • Aggressive Cut
              </div>
              <div class="head-item">
                <img src={arthroscopyshaverimage} alt="Tapered shaver head" />
                Tapered • Narrow Access
              </div>
              <div class="head-item">
                <img
                  src={arthroscopyshaverimage}
                  alt="Side window shaver head"
                />
                Side-Window • Debridement
              </div>
              <div class="head-item">
                <img
                  src={arthroscopyshaverimage}
                  alt="Burr style shaver head"
                />
                Burr / Bone Cutter
              </div>
            </div>
          </div>
          <div>
            <div class="card-subtitle">Handpiece Couplings</div>
            <p class="note">
              Multiple coupling types available. Match your shaver handpiece
              visually, or send a photo/drawing for confirmation.
            </p>
            <div class="coupling-strip">
              <div class="coupling-item">
                <img src={arthroscopyshaverimage} alt="Coupling Type A" />
                Coupling A
              </div>
              <div class="coupling-item">
                <img src={arthroscopyshaverimage} alt="Coupling Type B" />
                Coupling B
              </div>
              <div class="coupling-item">
                <img src={arthroscopyshaverimage} alt="Coupling Type C" />
                Coupling C
              </div>
              <div class="coupling-item">
                <img src={arthroscopyshaverimage} alt="Coupling Type D" />
                Coupling D
              </div>
              <div class="coupling-item">
                <img src={arthroscopyshaverimage} alt="Custom Coupling" />
                Custom
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="content-grid">
        <div>
          <article class="card">
            <div class="card-subtitle">Highlights</div>
            <h2>Key Features &amp; Performance</h2>
            <p>
              Arthroscopy shaver blades must combine fast, efficient cutting
              with smooth control and minimal clogging. Our designs and
              processes are tuned around those requirements.
            </p>
            <div class="feature-grid">
              <div class="feature-item">
                <div class="feature-title">Sharp, stable cutting</div>
                <div class="feature-text">
                  Precision-ground cutting edges and closely controlled
                  clearances between inner cutter and outer sleeve support
                  predictable cutting and smooth debridement.
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-title">Head options for every joint</div>
                <div class="feature-text">
                  Straight, serrated, taper, side-window and burr-style tips
                  available for knee, shoulder, hip, ankle and other
                  arthroscopic procedures.
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-title">Multi-system compatibility</div>
                <div class="feature-text">
                  Blade couplings are available in multiple standard types to
                  match a wide range of arthroscopy shaver handpieces already in
                  use.
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-title">Balanced shaft design</div>
                <div class="feature-text">
                  Concentric inner/outer tubes and balanced construction help
                  reduce vibration for a controlled feel at the tip.
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-title">Single-use sterility</div>
                <div class="feature-text">
                  Sterile-packed, disposable blades support infection control
                  protocols and eliminate reprocessing steps.
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-title">Custom/OEM options</div>
                <div class="feature-text">
                  Diameters, working lengths, head shapes, couplings and
                  branding can be customised to your procedure sets or OEM
                  requirements.
                </div>
              </div>
            </div>
          </article>
          <article class="card">
            <div class="card-subtitle">Overview</div>
            <h2>Product Description</h2>
            <p>
              Arthroscopy shaver blades are used in combination with powered
              shaver handpieces to cut, shave and debride soft tissue and bone
              within the joint space. The typical construction is a
              “tube-in￾tube” design, with an inner rotating or oscillating
              cutter moving inside a slotted outer sleeve.
            </p>
            <p>
              Sabiote shaver blades use medical-grade stainless steel for both
              inner cutter and outer sheath, with careful control of hardness
              and surface finish. Window shapes and edge profiles are optimised
              for efficient tissue resection and evacuation, helping maintain a
              clear arthroscopic view while avoiding unnecessary trauma to
              healthy structures.
            </p>
            <p>
              A range of diameters, working lengths and head types allows the
              surgeon to match the blade to joint size and pathology, whether
              performing meniscal debridement in the knee, labral work in the
              shoulder or general synovectomy.
            </p>
          </article>
          <article class="card">
            <div class="card-subtitle">Technical</div>
            <h2>Technical Specifications &amp; Options</h2>
            <table class="spec-table">
              <tr>
                <th>Structure</th>
                <td>
                  Coaxial inner cutter and outer sleeve shaver blade.
                  <br />
                  Distal cutting window or tip according to selected head type.
                </td>
              </tr>
              <tr>
                <th>Diameters*</th>
                <td>
                  Example range: Ø3.5 mm, 4.0 mm, 4.5 mm, 5.5 mm
                  <br />
                  Other diameters available on request.
                </td>
              </tr>
              <tr>
                <th>Working Length</th>
                <td>
                  Standard arthroscopy lengths (e.g. ~110–140 mm) – customised
                  lengths available for specific joints or techniques.
                </td>
              </tr>
              <tr>
                <th>Head Types</th>
                <td>
                  Straight open, serrated, taper, side-window, burr-style and
                  other geometries tailored to tissue type and indication.
                </td>
              </tr>
              <tr>
                <th>Materials</th>
                <td>
                  Inner cutter and outer sheath: medical-grade stainless steel.
                  <br />
                  Optional high-hardness or coated variants available upon
                  request.
                </td>
              </tr>
              <tr>
                <th>Coupling Types</th>
                <td>
                  Coupling A / B / C / D and custom – designed to interface with
                  multiple arthroscopy shaver systems already in the market.
                </td>
              </tr>
              <tr>
                <th>Usage</th>
                <td>
                  Single-use, sterile-packed shaver blades.*
                  <br />
                  Custom configurations for reusable blades can be discussed as
                  required.
                </td>
              </tr>
              <tr>
                <th>Packaging</th>
                <td>
                  Individual sterile pack, with standard multi-pack cartons for
                  hospital supply.
                  <br />
                  Private-label packaging available.
                </td>
              </tr>
            </table>
            <p class="note">
              *Confirm final diameter range, sterility mode and any reusable
              variants based on your actual product line.
            </p>
          </article>
          <article class="card">
            <div class="card-subtitle">Clinical Use</div>
            <h2>Indications &amp; Procedures</h2>
            <p>Arthroscopy shaver blades are intended for use in:</p>
            <ul>
              <li>
                Knee arthroscopy – meniscal trimming, cartilage debridement,
                synovectomy.
              </li>
              <li>
                Shoulder arthroscopy – rotator cuff and labral work, subacromial
                decompression.
              </li>
              <li>Hip arthroscopy – labral and cartilage debridement.</li>
              <li>
                Ankle and small joint arthroscopy – soft tissue and osteophyte
                work.
              </li>
              <li>
                General joint debridement and tissue sculpting, as directed by
                the surgeon.
              </li>
            </ul>
            <p class="note">
              Use only by trained arthroscopy surgeons and operating room staff
              familiar with powered shaver systems.
            </p>
          </article>
          <article class="card">
            <div class="card-subtitle">Safety</div>
            <h2>Use, Handling &amp; Safety Considerations</h2>
            <ul>
              <li>
                Verify correct coupling and secure locking of the blade onto the
                shaver handpiece before use.
              </li>
              <li>
                Inspect the blade and packaging; do not use if sterile barrier
                is compromised or if any damage is visible.
              </li>
              <li>
                Use appropriate suction and irrigation to avoid clogging and to
                control heat generation.
              </li>
              <li>
                Do not forcibly bend or twist the blade; avoid contact with hard
                metal objects such as cannulas or trocars.
              </li>
              <li>
                Dispose of single-use blades as sharps / clinical waste in
                accordance with local regulations.
              </li>
            </ul>
            <p class="note">
              Always consult the Instructions for Use (IFU) and the shaver
              handpiece manufacturer’s operating guidelines.
            </p>
          </article>
          <article className="card" id="faq">
            <div className="card-subtitle">Support</div>
            <h2>Frequently Asked Questions</h2>
            <div className="faq-item">
              <div className="faq-q" onClick={() => toggleFaq(0)}>
                Can you match blades we currently use from another supplier?
                <span className={`faq-arrow ${openIndex === 0 ? "open" : ""}`}>
                  ▼
                </span>
              </div>
              {openIndex === 0 && (
                <div className="faq-a">
                  Yes. With reference codes, drawings or physical samples, we
                  can match head type, diameter, length and coupling, and then
                  supply equivalent or custom-improved blades under Sabiote or
                  your own brand.
                </div>
              )}
            </div>
            <div class="faq-item">
              <div className="faq-q" onClick={() => toggleFaq(1)}>
                How do I choose the correct coupling type?
                <span className={`faq-arrow ${openIndex === 1 ? "open" : ""}`}>
                  ▼
                </span>
              </div>
              {openIndex === 1 && (
                <div class="faq-a">
                  You can compare your handpiece connector to the coupling
                  images (A/B/C/D) on this page or send us clear photos of the
                  handpiece tip. Our team will identify the best matching
                  coupling.
                </div>
              )}
            </div>
            <div class="faq-item">
              <div className="faq-q" onClick={() => toggleFaq(2)}>
                Do you offer reusable shaver blades?
                <span className={`faq-arrow ${openIndex === 2 ? "open" : ""}`}>
                  ▼
                </span>
              </div>
              {openIndex === 2 && (
                <div class="faq-a">
                  Our standard portfolio focuses on sterile single-use blades.
                  However, reusable constructions can be discussed for specific
                  projects, subject to regulatory and validation requirements in
                  your market.
                </div>
              )}
            </div>
            <div class="faq-item">
              <div className="faq-q" onClick={() => toggleFaq(3)}>
                Can we have our own logo and reference code on the blades?
                <span className={`faq-arrow ${openIndex === 3 ? "open" : ""}`}>
                  ▼
                </span>
              </div>
              {openIndex === 3 && (
                <div class="faq-a">
                  Yes. We support OEM/private-label engraving and packaging,
                  including your logo, REF/LOT and other traceability markings,
                  subject to minimum order quantities.
                </div>
              )}
            </div>
          </article>
        </div>
        <aside>
          <div class="card" id="quote">
            <div class="card-subtitle">Ordering</div>
            <h2>How to Specify Your Shaver Blade</h2>
            <p class="side-card-text">
              Use this configuration format when requesting a quotation or
              custom development:
            </p>
            <table class="spec-table">
              <tr>
                <th>1 – Joint / Use</th>
                <td>e.g. Knee / Shoulder / Hip / Ankle / Other.</td>
              </tr>
              <tr>
                <th>2 – Diameter</th>
                <td>
                  Specify blade outer diameter (mm), e.g. 4.0 / 4.5 / 5.5.
                </td>
              </tr>
              <tr>
                <th>3 – Working Length</th>
                <td>Standard or custom length (mm).</td>
              </tr>
              <tr>
                <th>4 – Head Type</th>
                <td>
                  Straight / Serrated / Tapered / Side-window / Burr / Custom.
                </td>
              </tr>
              <tr>
                <th>5 – Coupling Type</th>
                <td>
                  Coupling A / B / C / D / Custom (attach photos if unsure).
                </td>
              </tr>
              <tr>
                <th>6 – Use Type</th>
                <td>
                  Single-use sterile (default) or discuss reusable concept.
                </td>
              </tr>
              <tr>
                <th>7 – Branding</th>
                <td>
                  Sabiote label or OEM/private-label (with your logo and REF).
                </td>
              </tr>
            </table>
            <div class="side-divider"></div>
            <p class="side-card-heading">Ready to configure?</p>
            <p class="side-card-text">
              Send us your current shaver blade list, drawings or handpiece
              photos. We’ll map them to Sabiote part numbers or develop a custom
              blade matrix for you.
            </p>
            <a href="#contact" class="btn btn-outline">
              Send Requirements
            </a>
          </div>
          <div class="card">
            <div class="card-subtitle">OEM</div>
            <h2>OEM &amp; Custom Manufacturing</h2>
            <p class="side-card-text">
              As an OEM-capable manufacturer, we support:
            </p>
            <ul>
              <li>Head shapes and window designs to your drawings.</li>
              <li>Custom couplings for specific shaver systems.</li>
              <li>Engraving/marking with your logo and coding scheme.</li>
              <li>Neutral or fully branded packaging and IFUs.</li>
            </ul>
            <p class="note">
              NDA-based development and long-term supply agreements available
              for strategic partners.
            </p>
          </div>
          <div class="card">
            <div class="card-subtitle">Quality</div>
            <h2>Quality &amp; Compliance</h2>
            <p class="side-card-text">
              Blades are manufactured with traceable materials and controlled
              processes, supported by a formal quality management system.
            </p>
            <div class="pill-stack">
              <div class="pill">Medical-grade stainless steel</div>
              <div class="pill">Process validation &amp; inspection</div>
              <div class="pill">ISO 13485-aligned QMS*</div>
              <div class="pill">Regulatory registrations as applicable*</div>
            </div>
            <p class="note">
              *Update statements according to your actual certifications and
              registrations.
            </p>
          </div>
          <div class="card" id="downloads">
            <div class="card-subtitle">Resources</div>
            <h2>Downloads</h2>
            <ul className="download-list">
              <li>
                <a
                  href="arthro-shaver-blades-catalog.pdf"
                  className="download-link"
                >
                  <svg viewBox="0 0 20 20" fill="none">
                    <path
                      d="M5 9v6.5A1.5 1.5 0 0 0 6.5 17h7A1.5 1.5 0 0 0 15 15.5V9"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10 3v9m0 0 3-3.2M10 12 7 8.8"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Arthroscopy Shaver Blades – Catalog
                </a>
              </li>

              <li>
                <a
                  href="arthro-shaver-head-types-guide.pdf"
                  className="download-link"
                >
                  <svg viewBox="0 0 20 20" fill="none">
                    <path
                      d="M4 14.5V5.5A1.5 1.5 0 0 1 5.5 4h9"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                    />
                    <path
                      d="M6 9h3m-3 3h5m3.5-8v10A1.5 1.5 0 0 1 13 15.5H6"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                    />
                  </svg>
                  Head Type &amp; Indication Guide
                </a>
              </li>

              <li>
                <a
                  href="arthro-shaver-blades-ifu.pdf"
                  className="download-link"
                >
                  <svg viewBox="0 0 20 20" fill="none">
                    <circle
                      cx="10"
                      cy="10"
                      r="7"
                      stroke="currentColor"
                      strokeWidth="1.4"
                    />
                    <path
                      d="M10 6.3v4.1"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                    />
                    <circle cx="10" cy="13.4" r="0.7" fill="currentColor" />
                  </svg>
                  Instructions for Use (IFU)
                </a>
              </li>
            </ul>
          </div>
          <div class="card" id="contact">
            <div class="card-subtitle">Enquiries</div>
            <h2>Talk to Our Arthroscopy Team</h2>
            <p class="side-card-text">
              Share your current blade list, shaver system details and annual
              volume so we can propose an optimal configuration and commercial
              model.
            </p>
            <p class="side-card-text">
              Email:<a href="mailto:sales@sabiote.in">sales@sabiote.in</a>
              <br />
              <br />
              <a
                href={whatsappMessage}
                target="_blank"
                rel="noopener noreferrer"
                className="callback-btn"
              >
                <FaWhatsapp /> Book a Callback
              </a>
            </p>
          </div>
        </aside>
      </section>

      <footer class="footer-note">
        <strong>Disclaimer:</strong> Product availability, specifications and
        coupling options may vary by market. Arthroscopy shaver blades are
        intended for use by trained healthcare professionals only. Always refer
        to the product labelling, Instructions for Use and shaver system
        documentation before use.
      </footer>
    </div>
  );
};

export default ArthroscopyShaverBlades;
